// External dependencies
import React, { Component } from 'react';

// Internal dependencies
import SplashScreen from '../../Reports/blocks/Menu/Splash';
import { routeStore } from '../../../routes';
import { getUserData } from '../../../services/API';

class AdminPortal extends Component {
  render () {
    // Note: currently, district and school admins get access to the same stuff
    let adminPages = routeStore.DISTRICT_ADMIN.routes.filter(route =>
      (route && route.type && route.label && route.subtext && route.tagline && route.link && (!getUserData().subdistrictId || route.subdistrict))
    );

    if(!getUserData().districtAdminBadgingEnabled) {
      adminPages = adminPages.filter(route =>
        route.type != "badgingConfig"
      );
    }

    // Assume that if the user is a teacher and has a reporting role, they should only see reporting pages
    if(getUserData().reportingRole && getUserData().userType === "teacher") {
      adminPages = adminPages.filter(route =>
        route.type === "schoolResults" || route.type === "adminDashboard"
      );
    }
    return (
      <div className="reports-root-container">
        <div className="reports-page-wrap">
          <SplashScreen title="District Tools" blocks={adminPages}/>
        </div>
      </div>
    )
  }
}

export default AdminPortal;
